/**
 * @generated SignedSource<<24adfd3c6e32f44538690639f2ab7854>>
 * @relayHash 6baab84fb33d5b03a95e7fc260932ffd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a

import type { ConcreteRequest, Query } from 'relay-runtime';
export type AgentStudioAgentQueryInput = {
  includeDraftAgents?: boolean | null | undefined;
  name?: string | null | undefined;
  onlyEditableAgents?: boolean | null | undefined;
  onlyFavouriteAgents?: boolean | null | undefined;
  onlyMyAgents?: boolean | null | undefined;
  onlyPublishedEditableAgents?: boolean | null | undefined;
  onlyTemplateAgents?: boolean | null | undefined;
  onlyUnpublishedAgents?: boolean | null | undefined;
  onlyVerifiedAgents?: boolean | null | undefined;
};
export type getRovoAgentIdRelayQuery$variables = {
  cloudId: string;
  input?: AgentStudioAgentQueryInput | null | undefined;
  product?: string | null | undefined;
};
export type getRovoAgentIdRelayQuery$data = {
  readonly agentStudio_getAgents: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly externalConfigReference: string | null | undefined;
        readonly id: string;
        readonly name: string | null | undefined;
      } | null | undefined;
    }>;
  } | null | undefined;
};
export type getRovoAgentIdRelayQuery = {
  response: getRovoAgentIdRelayQuery$data;
  variables: getRovoAgentIdRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "product"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      },
      {
        "kind": "Variable",
        "name": "product",
        "variableName": "product"
      }
    ],
    "concreteType": "AgentStudioAgentsConnection",
    "kind": "LinkedField",
    "name": "agentStudio_getAgents",
    "plural": false,
    "selections": [
      {
        "concreteType": "AgentStudioAgentEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "concreteType": "AgentStudioAssistant",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "kind": "ScalarField",
                "name": "externalConfigReference"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "getRovoAgentIdRelayQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "getRovoAgentIdRelayQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "9e09a83e61fd43789aeb35b90e2f5c323733ae91a0c8a217868f45694be7598a",
    "metadata": {},
    "name": "getRovoAgentIdRelayQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2d164c49d934dbe7dee2500c2971c832";

export default node;
